import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

import { useAuthentication } from '@hooks/useAuthentication'
import { useCategories } from '@hooks/useCategories'
import { BookEnum } from '@interfaces/BookEnum'
import { TimeRangeEnum } from '@interfaces/TimeRangeEnum'
import { usePenNameAction } from '@hooks/penName/usePenNameAction'
import {
  SearchSaleAnalyticsProps,
  SearchSaleAnalyticsAcceptProps,
} from '../SearchSaleAnalytics/interfaces'

const bookType = [
  { value: BookEnum.NOVEL, label: 'นิยาย' },
  { value: BookEnum.MANGA, label: 'การ์ตูน' },
]

export function withSearchEbookSaleAnalytics(
  Component: React.FC<SearchSaleAnalyticsProps>
) {
  function WithSearchEbookSaleAnalytics(props: SearchSaleAnalyticsAcceptProps) {
    const router = useRouter()
    const penNameClient = usePenNameAction()
    const { user } = useAuthentication()
    const { data: penNameOptions = [] } = useQuery(
      ['pen-name-options', user?.id],
      () =>
        penNameClient.getPenNameOptions(user?.id).then(res =>
          res.map(row => ({
            ...row,
            value: String(row.value),
          }))
        ),
      { enabled: !!user.id }
    )

    const { categories } = useCategories()
    const [ebookAdvanceSearch, setEbookAdvanceSearch] = useState<boolean>(
      router.query.ebookAdvanceSearch === 'true'
    )

    useEffect(() => {
      if (router.query.ebookAdvanceSearch) {
        setEbookAdvanceSearch(router.query.ebookAdvanceSearch === 'true')
      }
    }, [router.query.ebookAdvanceSearch])

    function handleAdvanceSearchChange() {
      setEbookAdvanceSearch((prev: boolean) => !prev)

      router.replace(
        {
          pathname: router.pathname,
          query: {
            tab: 'salesAnalytics',
            ebookAdvanceSearch: !ebookAdvanceSearch,
            ...(router.query.ebookId && { ebookId: router.query.ebookId }),
            ...(router.query.subtab && { subtab: router.query.subtab }),
          },
        },
        undefined,
        { scroll: false }
      )
    }

    const pageProps = {
      ...props,
      bookType,
      categories,
      penNameOptions,
      advanceSearch: ebookAdvanceSearch,
      handleAdvanceSearchChange,
    }
    return <Component {...pageProps} />
  }

  return WithSearchEbookSaleAnalytics
}
